import React, { useEffect, useState } from "react";
import { MoveLeft } from "lucide-react";
import inspection from "../../assets/svg/Inspection/viewInspection.svg";
import "../Vehicles/Vehicle_list/List.css";
import redLocation from "../../assets/svg/Inspection/redLocation.svg";
import { useNavigate, useLocation } from "react-router-dom";
import tata from "../../assets/Vehicles/tata.png";
import calender from "../../assets/svg/Inspection/calenderWithClock.svg";
import fail from "../../assets/svg/Inspection/fail.svg";
import pass from "../../assets/svg/Inspection/pass.svg";
import sign from "../../assets/SecondaryInspection/sign.svg";
import user from "../../assets/SecondaryInspection/user.svg";
import clock from "../../assets/SecondaryInspection/clock.svg";
import { getInspectionHistoryDetailsApi } from "./inspection-api.js";

export const ViewSecondaryInspection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};

  useEffect(() => {
    if (id != null && id !== undefined && id !== 0) {
      getInspectionDetails();
    }
  }, [id]);

  const [inspectionDetail, setInspectionDetail] = useState({});

  const getInspectionDetails = async () => {
    try {
      const response = await getInspectionHistoryDetailsApi(id);

      if (response.data.success === true) {
        setInspectionDetail(response.data.history ?? {});
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const details = [
    {
      label: "Start date & Time",
      value: (
        <div className="d-flex align-items-center gap-2">
          <img src={calender} alt="calender" />
          <span>{inspectionDetail.start_date}</span>
        </div>
      ),
    },
    {
      label: "Submission By",
      value: (
        <div className="d-flex align-items-center gap-2">
          <img src={user} alt="calender" />
          <span style={{ color: "#172B4D" }}>{inspectionDetail.user}</span>
        </div>
      ),
    },
    {
      label: "Duration",
      value: (
        <div className="d-flex align-items-center gap-2">
          <img src={clock} alt="clock" />
          <span style={{ color: "#471070" }}>{inspectionDetail.duration}</span>
        </div>
      ),
    },
  ];
  return (
    <>
      <div className="">
        <div className="d-flex flex-wrap justify-content-between align-items-center bg-white p-3">
          <div className="d-flex align-items-center gap-3">
            <div
              className="border p-2 rounded-circle cursor-pointer"
              onClick={() => {
                navigate(-1);
              }}
            >
              <MoveLeft />
            </div>
            <div className="rounded-4 p-4" style={{ backgroundColor: "#F5F2FF" }}>
              <img src={inspection} alt="tata" />
            </div>
            <div>
              {/* <p className="m-0 fs-20 fw-600 mb-1">INS8738456</p> */}
              <div className="d-flex flex-wrap align-items-center">
                <span className="me-2 text-dark-purple">{inspectionDetail.type ?? ""}</span>
                <span className="me-2" style={{ color: "#D9D9D9" }}>
                  •
                </span>
                <span className="border-0 d-flex align-items-center gap-2 pagination-color py-1 px-3 rounded-pill " style={{ backgroundColor: "#FFEFEF" }}>
                  <img src={redLocation} alt="redlocation" />
                  {inspectionDetail.location ?? ""}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0 p-3">
          <div className="col-xl-6">
            <div className="bg-white h-100 p-3 rounded-4">
              <div className="p-3 rounded-4" style={{ backgroundColor: "#F8F8F8" }}>
                <div className="d-flex gap-3">
                  <div className="rounded-4" style={{ backgroundColor: "#E8E8E8" }}>
                    <img src={tata} alt="tata" />
                  </div>
                  <div>
                    <p className="m-0 fs-20 fw-semibold mb-1">{inspectionDetail.lic_no ?? ""}</p>
                    <div className="d-flex align-items-center">
                      <span className="me-2 text-muted-grey">{inspectionDetail.vehicle_name ?? ""}</span>
                      <span className="me-2">•</span>
                      <span className="border-0 bg-list-purple text-dark-purple py-1 px-4 rounded-pill">{inspectionDetail.model ?? ""}</span>
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-4 mt-3 p-2 d-flex justify-content-start">
                  <span style={{ color: "#8790A1" }}>Vehicle identification number (VIN) :</span>
                  <span>&nbsp;{inspectionDetail.vin ?? ""}</span>
                </div>
              </div>
              <p className="fs-16 fw-600 m-0 mt-3">Inspection details</p>
              <div className="table-container rounded-4 overflow-hidden my-3">
                <table className="table table-borderless mb-0">
                  <tbody>
                    {details.map((item, index) => (
                      <tr key={index}>
                        <td className="fs-13 fw-500 w-25" style={{ color: "#49494B" }}>
                          {item.label}
                        </td>
                        <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                          {item.value}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-xl-3">
            <div className="bg-white h-100 rounded-4 p-3 mt-3 mt-xl-0">
              <p className="fs-16 fw-600">Interior details</p>
              {inspectionDetail?.interiors?.map((item, index) => (
                <>
                  {index !== 0 && <hr style={{ color: "#EBEBEB" }} />}
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="m-0 pagination-color">{item.name}</p>
                    {item.status === false && (
                      <div className="d-flex  gap-2">
                        <img src={fail} alt="fail" />
                        <p className="m-0" style={{ color: "#FF4444" }}>
                          Fail
                        </p>
                      </div>
                    )}
                    {item.status === true && (
                      <div className="d-flex  gap-2">
                        <img src={pass} alt="fail" />
                        <p className="m-0" style={{ color: "#2C8C53" }}>
                          Pass
                        </p>
                      </div>
                    )}
                  </div>
                </>
              ))}
            </div>
          </div>
          <div className="col-xl-3">
            <div className="bg-white h-100 rounded-4 p-3 mt-4 mt-xl-0">
              <p className="fs-16 fw-600">Exterior details</p>
              {inspectionDetail?.exteriors?.map((item, index) => (
                <>
                  {index !== 0 && <hr style={{ color: "#EBEBEB" }} />}
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="m-0 pagination-color">{item.name}</p>
                    {item.status === false && (
                      <div className="d-flex  gap-2">
                        <img src={fail} alt="fail" />
                        <p className="m-0" style={{ color: "#FF4444" }}>
                          Fail
                        </p>
                      </div>
                    )}
                    {item.status === true && (
                      <div className="d-flex  gap-2">
                        <img src={pass} alt="fail" />
                        <p className="m-0" style={{ color: "#2C8C53" }}>
                          Pass
                        </p>
                      </div>
                    )}
                  </div>
                </>
              ))}
            </div>
          </div>
          <div className="col-xl-4">
            <div className="bg-white rounded-4 p-3 mt-5 mt-xl-3 h-100">
              <p className="m-0 fs-16 fw-600 mt-2">Kilometer</p>
              <p className="m-0 fs-24 fw-500 pt-3">{inspectionDetail.km ?? ""} km</p>
            </div>
          </div>
          <div className="col-xl-4 mt-3 mt-xl-0">
            <div className="bg-white rounded-4 p-3 mt-5 mt-xl-3 h-100">
              <p className="m-0 fs-16 fw-600 mt-2">Remarks</p>
              <p className="m-0 fs-13 fw-400 pt-3 mt-1">{inspectionDetail.remark ?? ""}</p>
            </div>
          </div>
          <div className="col-xl-4 my-3 my-xl-0">
            <div className="bg-white d-flex rounded-4 p-3 my-5 mt-xl-3 h-100 align-items-start justify-content-between">
              <p className="m-0 fs-16 fw-600">Driver Signature</p>
              {/*  <p className="m-0 fs-16 fw-600">:</p> */}
            </div>
            {inspectionDetail.signature !== "" && <img src={inspectionDetail.signature ?? ""} alt="sign" />}
          </div>
          <div className="col-12 mt-5 mt-xl-4">
            <div className="bg-white rounded-4 p-3 mt-2">
              <div className="d-flex flex-wrap my-2 mb-3 align-items-center justify-content-between">
                <p className="m-0 mb-3 mb-xl-0 fs-16 fw-600">Inspection Location</p>
                <div>
                  <button className="px-3 py-1 rounded-start bg-transparent" style={{ border: "1px solid #EBEBEB", color: "#7157C2" }}>
                    Map
                  </button>
                  <button className="px-3 py-1 bg-transparent rounded-end" style={{ border: "1px solid #EBEBEB" }}>
                    Satelite
                  </button>
                </div>
              </div>
              <iframe className="rounded-4" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3816020.445834813!2d79.67903885728207!3d20.92911158612709!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a261f16c67a8bad%3A0x5c23f412fb179d95!2sChhattisgarh!5e0!3m2!1sen!2sin!4v1758022475544!5m2!1sen!2sin" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="map"></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
